import normalizeUrl from './cityDetail/normalizeUniversityUrl';

const MobileDiscoveryUniversityCard = ({ university }) => {
    const href = normalizeUrl(university.url);
    const students = university.studentsNumber || 'N/A';
    const formattedStudents = students !== 'N/A' && Number.isFinite(Number(students))
        ? Number(students).toLocaleString('en-US')
        : students;

    return (
        <article className="mobile-company-card mobile-university-card">
            <div className="mobile-company-card__body">
                <div className="mobile-company-card__top">
                    <div className="mobile-company-card__meta">
                        <h4 className="mobile-company-card__title">{university.name || 'N/A'}</h4>
                        <p className="mobile-university-card__classification">{university.classification || 'N/A'}</p>
                        <p className="mobile-university-card__detail">{university.address || 'N/A'}</p>
                        <p className="mobile-university-card__detail">{university.telephone || 'N/A'}</p>
                    </div>
                </div>
            </div>
            <div className="mobile-company-card__stats-strip mobile-company-card__stats-strip--two" aria-label="University details">
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">Students</span>
                    <span className="mobile-company-card__stat-value">{formattedStudents}</span>
                </div>
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">Website</span>
                    {href ? (
                        <a className="mobile-company-card__stat-value mobile-university-card__website"
                            href={href} target="_blank" rel="noopener noreferrer" title={university.url}>
                            {new URL(href).hostname}
                        </a>
                    ) : (
                        <span className="mobile-company-card__stat-value">—</span>
                    )}
                </div>
            </div>
        </article>
    );
};

export default MobileDiscoveryUniversityCard;
